<div class="bg-on-primary rounded-xl flex flex-col h-full mx-1">
    @if (isLoading()) {
        <app-loading class="h-full" />
    } @else {
        @if (!errorWhileFetchingOrganizationStandards()) {
            @if (!isStandardAvailable()) {
                <div class="flex justify-center items-center m-auto w-full h-full">
                    <app-no-data-to-display
                        class="h-full"
                        iconSize="5x"
                        information="noStandardsFound" />
                </div>
            } @else if (!isStandardSelected()) {
                <app-select-statistics-panel
                    class="h-full"
                    [data]="standardOptions()"
                    [icon]="['fad', 'chart-line']"
                    [placeholder]="'selectStandard'"
                    [subtitle]="'statisticsDisplayLinkedToThis'"
                    [title]="'selectStandard'"
                    (selectionChange)="onStandardChange($event)" />
            } @else {
                <div class="flex flex-col grow p-4 mx-1 overflow-hidden">
                    <div class="mb-6">
                        <app-main-title
                            iconColor="text-custom-blue"
                            iconSize="xl"
                            titleSize="text-2xl"
                            [icon]="isEditOrderMode() ? ['far', 'arrow-left'] : ['fas', ActionsEnum.STATISTICS]"
                            [isIconAction]="isEditOrderMode()"
                            [title]="'statistics' | transloco"
                            (actionClicked)="backToDashboard()" />
                    </div>
                    <div
                        #headerPanel
                        class="w-full flex gap-4 mb-2"
                        [class.flex-col]="isNarrowPanel()"
                        [class.flex-row]="!isNarrowPanel()">
                        <div class="flex flex-col w-full md:w-auto">
                            <p class="text-body-1 mb-2">
                                {{ 'selectStandard' | transloco }}
                            </p>
                            <app-select
                                [canClear]="false"
                                [isMultiSelect]="false"
                                [options]="standardOptions()"
                                [placeholder]="standardNameSelected()"
                                (optionSelected)="onStandardChange($event)" />
                            @if (statisticService.isLoading()) {
                                <app-loading
                                    class="ml-2 mt-6 self-start"
                                    [hasMessage]="false"
                                    [size]="20"
                                    [strokeWidth]="2" />
                            } @else if (statisticService.versionAndDataName().length) {
                                <div class="w-50 min-w-[10rem] my-2">
                                    <app-readonly-dropdown-list
                                        [label]="'dataUsedList' | transloco"
                                        [options]="statisticService.versionAndDataName()" />
                                </div>
                            } @else {
                                <button
                                    class="p-0"
                                    mat-button>
                                    <span class="underline">
                                        {{ 'noDepositCreated' | transloco }}
                                    </span>
                                </button>
                            }
                        </div>
                        <div class="flex flex-col md:items-end justify-between h-full flex-1 min-w-0">
                            <div
                                class="flex"
                                [class]="statisticService.isMapExpanded() ? 'flex-col' : 'flex-row'">
                                <app-statistic-geographic-filter-actions />
                                <app-button
                                    class="self-end"
                                    [class.my-1]="statisticService.isMapExpanded()"
                                    [disabled]="isExportingExcel()"
                                    [icon]="['fas', 'arrow-down-to-line']"
                                    [label]="'export' | transloco"
                                    [loading]="isExportingExcel()"
                                    [matMenuTriggerFor]="exportMenu"
                                    [type]="ButtonType.SECONDARY" />
                                <mat-menu #exportMenu="matMenu">
                                    <button
                                        mat-menu-item
                                        type="button"
                                        (click)="openStatsPage()">
                                        PDF
                                    </button>
                                    <button
                                        mat-menu-item
                                        type="button"
                                        [disabled]="isExportingExcel()"
                                        (click)="exportStatisticsAsExcel()">
                                        Excel
                                    </button>
                                </mat-menu>
                            </div>

                            <div
                                class="flex"
                                [class]="statisticService.isMapExpanded() ? 'flex-col gap-y-2' : 'flex-row'">
                                @if (!isEditOrderMode()) {
                                    <app-button
                                        [icon]="['fas', 'pen']"
                                        [label]="'edit' | transloco"
                                        [type]="ButtonType.SECONDARY"
                                        (onClick)="toggleEditOrderMode()" />
                                } @else {
                                    <app-button
                                        class="self-end"
                                        [class.mr-2]="!statisticService.isMapExpanded()"
                                        [icon]="['fas', 'rotate']"
                                        [label]="'defaultDisplay' | transloco"
                                        [type]="ButtonType.SECONDARY"
                                        (onClick)="resetStatisticsOrder()" />
                                    <app-button
                                        class="self-end"
                                        [disabled]="!hasUnsavedStatisticOrderChanges()"
                                        [icon]="['fas', 'pen']"
                                        [label]="'save' | transloco"
                                        [type]="ButtonType.PRIMARY"
                                        (onClick)="saveStatisticOrder()" />
                                }
                            </div>
                        </div>
                    </div>

                    <div class="overflow-y-auto overflow-x-hidden h-full">
                        @if (!isEditOrderMode()) {
                            <app-statistics-panel />
                        } @else {
                            <app-edit-order (orderChanged)="hasUnsavedStatisticOrderChanges.set(true)" />
                        }
                    </div>
                </div>
            }
        } @else {
            <div class="flex justify-center items-center m-auto w-full h-fit">
                <app-no-data-to-display
                    iconSize="5x"
                    information="errorWhileFetchingOrganizationStandards" />
            </div>
        }
    }
</div>
